import _ from 'lodash'
import Model from 'scoreboard/reports/dataset-report/dataset-report-model'
import NewView from './choose-dataset-step'
import i18n from 'scoreboard/components/i18n'

const Path = {
	steps: [{
		titleCode: 'report.designer.newReportChooseDataset',
		confirmCode: 'report.designer.createReport',
		view: NewView,
		validate: function (attrs, opts) {
			return _.isNil(attrs.dataset)
		},
		testNext: function (attrs) {
			if (_.isNil(attrs.dataset) || attrs.dataset.type != 'dataset') {
				return i18n.get('datasets.pleaseSelect')
			}
			if (!attrs.dataset.viewRecords) {
				return i18n.get('report.designer.mustHaveViewRecordsPermissionsForDataset')
			}

		}
	}],
	model: Model
}

export default Path

Path.__filename__ = 'reports/wizard/dataset-report/dataset-report-path.js'
